/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type SnakeTabResponseDtoSection = (typeof SnakeTabResponseDtoSection)[keyof typeof SnakeTabResponseDtoSection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SnakeTabResponseDtoSection = {
  ORDER_BOOK: 'ORDER_BOOK',
  MARKET_RULES: 'MARKET_RULES',
  TIMELINE_PAYOUT: 'TIMELINE_PAYOUT',
  PEOPLE_ALSO_TRADING: 'PEOPLE_ALSO_TRADING',
  PEOPLE_SAYING: 'PEOPLE_SAYING',
} as const;
